import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ConfigProvider } from 'antd';
import moment from 'moment';
import 'moment/locale/zh-hk';
import locale from 'antd/lib/locale/zh_HK';
// import "./network/apiRequest/user";

import './i18n.js';

ReactDOM.render(
<ConfigProvider locale={locale}>
  <App />
</ConfigProvider>
, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();